import { Stack, Typography } from "@mui/material";
import {
  AlertCircle,
  Dialog,
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { useTranslation } from "react-i18next";

interface MissingEmailIdErrorDialogProps {
  missingEmailIdCount: number;
  closeDialog: VoidFunction;
}

const DIALOG_WIDTH = "560px";
const ALERT_ICON_SIZE = "20px";
const MISSING_EMAIL_ID_STATISTIC_WRAPPER_WIDTH = "274px";

export const MissingEmailIdErrorDialog: React.FC<
  MissingEmailIdErrorDialogProps
> = ({ missingEmailIdCount, closeDialog }) => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const tokens = useFoundationColorTokens();
  const typography = useTypography();

  return (
    <Dialog
      title={t("emailCycles.missingEmailIdErrorTitle")}
      secondaryButtonText={t("common.close")}
      onSecondaryButtonClick={closeDialog}
      width={DIALOG_WIDTH}
      open
      disableBackdropClick={true}
    >
      <Stack gap={spacing.spaceLG}>
        <Stack
          direction="row"
          gap={spacing.spaceXS}
          color={tokens.labelWarning}
        >
          <AlertCircle
            height={ALERT_ICON_SIZE}
            width={ALERT_ICON_SIZE}
            style={{ flexShrink: 0 }}
          />
          <Typography {...typography.b2}>
            {t("emailCycles.missingEmailIdErrorMessage")}
          </Typography>
        </Stack>

        <Stack width={MISSING_EMAIL_ID_STATISTIC_WRAPPER_WIDTH}>
          <Stack direction="row" paddingBlock={spacing.spaceXS}>
            <Typography
              {...typography.b1}
              color={tokens.labelSubtle}
              sx={{ flex: 1 }}
            >
              {t("emailCycles.respondentsWithoutEmail")}
            </Typography>
            <Typography {...typography.s1} color={tokens.label}>
              {missingEmailIdCount}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
};
